import "./index.scss";
import "../index.scss";
import { useState } from "react";
import PropTypes from "prop-types";
import ReadyToStart from "../ReadyToStart";
import { displayGameName, fetchImage } from "../../nonUIFuncs";
import { store } from "../../../Store";

const DisplayMultiCategories = (props) => {
  let multiCategoryArray = props.levelData.filter(
    (datum) => datum.spreadGameType === props.game,
  );
  let compressGame = props.game.replace(/ /g, "");
  multiCategoryArray = multiCategoryArray.filter(
    (datum) => datum.gameType !== compressGame,
  );
  multiCategoryArray = multiCategoryArray.filter(
    (datum) => datum.gameType !== "WhackAMole",
  );
  let gameTypeArray = [];
  let finalMultiCategoryArray = multiCategoryArray.map((datum) => {
    if (!gameTypeArray.includes(datum.gameType)) {
      gameTypeArray.push(datum.gameType);
      return datum;
    }
    return undefined; // dropped by the filter below
  });
  finalMultiCategoryArray = finalMultiCategoryArray.filter(
    (d) => d !== undefined && typeof d.category !== "string",
  );
  let multiCatDOM = finalMultiCategoryArray.map((datum) => {
    return (
      <div key={datum.gameType} className="EM-CS-content">
        <div className="EM-CS-title">{displayGameName(datum.gameType)}</div>
        <div className="EM-CS-innerContainer">
          {datum.levelEasy === 0 ? (
            <div className="EM-CS-circContainer">
              <div className="EM-CS-easyCirc">E</div>Lvl {datum.levelEasy}
            </div>
          ) : (
            <div className="EM-CS-circContainer">
              <div className="EM-CS-easyCircFull">
                <div className="EM-CS-categoryContainer">
                  {datum.categoryEasy.map((string) => (
                    <div key={string}>{string}</div>
                  ))}
                </div>
                <div>E: Lvl {datum.levelEasy}</div>
              </div>
            </div>
          )}
          {datum.levelMedium === 0 ? (
            <div className="EM-CS-circContainer">
              <div className="EM-CS-mediumCirc">M</div>Lvl {datum.levelMedium}
            </div>
          ) : (
            <div className="EM-CS-circContainer">
              <div className="EM-CS-mediumCircFull">
                <div className="EM-CS-categoryContainer">
                  {datum.categoryMedium.map((string) => (
                    <div key={string}>{string}</div>
                  ))}
                </div>
                <div>M: Lvl {datum.levelMedium}</div>
              </div>
            </div>
          )}
          {datum.levelHard === 0 ? (
            <div className="EM-CS-circContainer">
              <div className="EM-CS-hardCirc">H</div>Lvl {datum.levelHard}
            </div>
          ) : (
            <div className="EM-CS-circContainer">
              <div className="EM-CS-hardCircFull">
                <div className="EM-CS-categoryContainer">
                  {datum.categoryHard.map((string) => (
                    <div key={string}>{string}</div>
                  ))}
                </div>
                <div>H: Lvl {datum.levelHard}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  });
  return <div className="EM-CS-container">{multiCatDOM}</div>;
};

/** One category: its picture, name and best Endless levels, picked or not. */
const levelOf = (levelData, game, category) =>
  levelData.find((d) => {
    if (d.spreadGameType !== game) return false;
    const c = d.category.length === 1 ? d.category[0] : d.category;
    return c === category;
  }) ?? {};

const DisplayCategories = (props) => {
  const { gameData, vocabData, storybookVocab } = store.getState().store.value;
  return props.categories.map((datum, i) => {
    let found = vocabData.find((d) => d.homeName === datum);
    let isStory = false;
    if (found === undefined) {
      found = storybookVocab?.find((d) => d.homeName === datum);
      isStory = true;
      if (found === undefined) return null;
    }
    const lesson = found.lesson !== undefined ? found.lesson : found.story;
    const image = isStory ? `Category_Selection_Story_${lesson}.png` : `Category_Selection_${lesson}1.png`;
    const shown = gameData.find((g) => g.category === datum)?.categoryLanguage || datum;
    const picked = props.chosenCategories.includes(datum);
    const full = !picked && props.chosenCategories.length >= 5;
    const level = levelOf(props.levelData, props.game, datum);
    return (
      <button
        key={datum}
        id={datum}
        type="button"
        className={`em2_chip${picked ? " em2_chip--picked" : ""}`}
        style={{ "--order": Math.min(i, 16) }}
        onClick={() => props.updateCategories(datum)}
        disabled={full}
        aria-pressed={picked}
        aria-label={`${picked ? "Deselect" : "Select"} category: ${shown}`}
      >
        <span className="em2_chipPicture" style={{ backgroundImage: `url(${fetchImage(image)})` }} />
        <span className="em2_chipName aboriginalSans">{shown}</span>
        <span className="em2_chipLevels" aria-hidden="true">
          <span className="em2_lvl em2_lvl--e">{level.levelEasy ?? 0}</span>
          <span className="em2_lvl em2_lvl--m">{level.levelMedium ?? 0}</span>
          <span className="em2_lvl em2_lvl--h">{level.levelHard ?? 0}</span>
        </span>
        {picked && (
          <span className="em2_check" aria-hidden="true">
            ✓
          </span>
        )}
      </button>
    );
  });
};

const CategorySelect = (props) => {
  const [shouldSetCategories, setShouldSetCategories] = useState(false);
  const resetCategories = () => {
    props.resetCategories();
    setShouldSetCategories(false);
  };
  return (
    <div className="EM-CS-fullscreen">
      <div className="EM-topBanner">
        <div className="EM-topBanner-inner">
          {displayGameName(props.game)}
          <div className="EM-CS-topBannerSub">Choose up to 5 categories</div>
        </div>
      </div>
      <div className="em2_bar">
        <button type="button" className="em2_back badaBoom" onClick={() => props.setDisplay("games")} aria-label="Go back to game selection">
          ◀ Back
        </button>
        <span className="em2_count badaBoom" aria-live="polite">
          {props.chosenCategories.length} / 5
        </span>
        <button
          type="button"
          className="em2_go badaBoom"
          disabled={props.chosenCategories.length === 0}
          onClick={() => setShouldSetCategories(true)}
          aria-label="Continue with selected categories"
        >
          Next ▶
        </button>
      </div>
      {props.chosenCategories.length >= 5 || shouldSetCategories === true ? (
        <ReadyToStart
          categories={props.chosenCategories}
          resetCategories={resetCategories}
        >
          <div className="EM-CS-RTS-container">
            <div className="EM-CS-RTS-innerContainer">
              <div className="EM-CS-RTS-titletext">
                Do you want to choose new categories or continue?
              </div>
              <div className="EM-CS-categoryDisplay">
                {props.chosenCategories.map((datum) => (
                  <div className="EM-CS-RTS-catStringContainer" key={datum}>
                    {datum}
                  </div>
                ))}
              </div>
            </div>
            <div className="EM-CS-RTS-buttonContainer">
              <div className="EM-CS-button-goback" onClick={resetCategories}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); resetCategories(); } }}
                role="button" tabIndex={0} aria-label="Reselect categories">
                Reselect
              </div>
              <div
                className="EM-CS-button-continue"
                onClick={() => props.setDisplay("difficulty")}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); props.setDisplay("difficulty"); } }}
                role="button" tabIndex={0} aria-label="Continue to difficulty selection"
              >
                Continue
              </div>
            </div>
          </div>
        </ReadyToStart>
      ) : null}
      <div className="EM-container em2_scroll">
        <div className="em2_grid">
          <DisplayCategories
            categories={props.categories}
            chosenCategories={props.chosenCategories}
            game={props.game}
            levelData={props.levelData}
            updateCategories={props.updateCategories}
          />
        </div>
        <details className="em2_records">
          <summary className="badaBoom">Best levels with more than one category</summary>
          <DisplayMultiCategories game={props.game} levelData={props.levelData} />
        </details>
      </div>
    </div>
  );
};

export default CategorySelect;

CategorySelect.propTypes = {
  categories: PropTypes.array,
  chosenCategories: PropTypes.array,
  game: PropTypes.string,
  levelData: PropTypes.array,
  resetCategories: PropTypes.func,
  setDisplay: PropTypes.func,
  updateCategories: PropTypes.func,
};

DisplayMultiCategories.propTypes = {
  game: PropTypes.string,
  levelData: PropTypes.array,
};

DisplayCategories.propTypes = {
  categories: PropTypes.array,
  chosenCategories: PropTypes.array,
  data: PropTypes.array,
  game: PropTypes.string,
  levelData: PropTypes.array,
  updateCategories: PropTypes.func,
};
